import { ReactElement, type FC } from "react";

import BreadCrumbsMUI from "../../components/molecules/breadcrumpMUI/breadcrumpMUI";
import { useUser } from "../../context";
import * as s from "./styled-finances-home";

const rotes = [
    {
        label: "Orçamentos",
        href: "/financial",
    },
];

export const Layout = ({
    children,
    disableTitle = false,
    name,
}: {
    children: ReactElement;
    disableTitle?: boolean;
    name?: string;
}) => {
    const { verifyPermission } = useUser();
    const organizationPermission = verifyPermission({
        id: "manage_teams_projects",
        rule: "enabled",
    });
    return (
        <s.Container>
            {organizationPermission && (
                <BreadCrumbsMUI
                    breadcrumpRotes={rotes}
                    currentRote={name || "Novo Orçamento"}
                />
            )}
            {!disableTitle && <s.Title>Orçamentos</s.Title>}
            {children}
        </s.Container>
    );
};
